import { useEffect, useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  useTheme,
  useMediaQuery,
  Typography,
  IconButton,
  Grid,
  Dialog,
  Divider,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Draggable from "react-draggable";
import { useHistory } from "react-router-dom";
import no_data from "../../../../Image/no_data.png";
import CloseIcon from "@mui/icons-material/Close";
import icon_edit from "../../../../Image/icon_edit.png";
import dayjs from "dayjs";
import DialogSuccessEditTable from "./DialogPersonal/DialogSuccessEditTable";
import DialogNoInformationFound from "./DialogPersonal/DialogNoInformationFound";
import {
  GetLocalStorageAccessToken,
  webapi,
  APIEndpointWeb,
} from "../../../../client/web";
import LoadingIndicator from "./Loading/LoadingIndicator";

// function createData(
//   document_no: string,
//   type: string,
//   createdDate: string,
//   status: string,
//   priority: string
// )
// {
//   return { document_no, type, createdDate, status, priority };
// }

interface tableData {
  document_no: string;
  type: string;
  create_at: string;
  status: string;
  priority: string;
  status_edit: boolean;
}

interface IDetailWitness {
  document_no: string,
  priority: string,
  account_id_by_one_id: string,
  cid: string,
  prefix: string,
  name: string,
}



const buttonContainerSx = {
  backgroundColor: "#fff",
  borderRadius: "8px",
  boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
  padding: "4px",
  minWidth: "16px",
};
const prefix = [
  { label: "นาย", value: "นาย" },
  { label: "นาง", value: "นาง" },
  { label: "นางสาว", value: "นางสาว" },
];

export default function TablePersonalDataAgree({
  selectedTab,
  searchString,
  setDocumentList,
}: {
  selectedTab: string;
  searchString: string;
  setDocumentList: React.Dispatch<React.SetStateAction<tableData[]>>;
}) {
  const theme = useTheme();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // xs และ sm
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // sm - md
  const [items, setItems] = useState([
    { id: "1", content: "ณราวิชณ์ เลิศศักด์ยืน", disabled: true },
    { id: "2", content: "ภูวินทร์ ศักดิ์โกสุม", disabled: true },
    { id: "3", content: "ณรา ตั้งรัตน์", disabled: true },
    { id: "4", content: "วิชุดา ยาชัยสินธุ์", disabled: false },
  ]);
  const [copied, setCopied] = useState(false);



  const [resWitness, setResWitness] = useState<IDetailWitness>({} as IDetailWitness);
  const [selectedValue, setSelectedValue] = useState<string | undefined>(undefined);
  const [nameData, setNameData] = useState<string | undefined>(undefined);
  const [cidData, setCidData] = useState<string | undefined>(undefined);

  const [openOrderDocDialog, setOpenOrderDocDialog] = useState(false);
  const [errorTextStatus, setErrorTextStatus] = useState('');
  const [errorTextStatus2, setErrorTextStatus2] = useState('');

  const history = useHistory();
  const [error, setError] = useState(false);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [row, setRow] = useState<tableData[]>([]);
  const [accessToken, setAccessToken] = useState<string>(
    GetLocalStorageAccessToken()
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [account_id, setAccount_id] = useState("");
  const [priority, setPriority] = useState("");
  const [document_no, setDocument_no] = useState("");
  const [unlockSearchString, setUnlockSearchString] = useState<boolean>(false);



  useEffect(() => {
    const fetchData = async () => {
      let personData: any = await sessionStorage.getItem("Data");
      const parsedAccountId = JSON.parse(personData);
      setAccount_id(parsedAccountId.result.data.account_id);
      setUnlockSearchString(true); // Set to true when data is fetched
    };

    fetchData().then(() => {
      handleOkSentFeelback();
    });
  }, [selectedTab]);


  useEffect(() => {
    if (unlockSearchString) {
      handleOkSentFeelback(searchString)
    }
  }, [searchString])


  useEffect(() => {
    if (openOrderDocDialog) {
      handleDetailPerson();
    }
  }, [openOrderDocDialog]);


  useEffect(() => {
    if (resWitness) {
      setSelectedValue(resWitness.prefix || "");
      setNameData(resWitness.name || "");
      setCidData(resWitness.cid ? String(resWitness.cid) : "");
    }
  }, [resWitness]);

  const handleOkSentFeelback = async (searchData: string = "") => {
    try {
      setLoading(true);
      let organization = (await sessionStorage.getItem("organization"))
        ? JSON.parse(sessionStorage.getItem("organization") as string)
        : null;
      // accessToken
      // console.log(organization.hcode)
      var { data } = await webapi.get(`${APIEndpointWeb.GetTableList}?hcode=${organization.hcode ? organization.hcode : ""}&search=${searchString}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      let documentList = data.result && data.result.length > 0 ? data.result : [];
      // กรองข้อมูลตาม selectedTab
      const filteredRows =
        selectedTab === "ทั้งหมด"
          ? documentList
          : documentList.filter((row: tableData) => {
            const statusMap: Record<string, string> = {
              เสร็จสิ้น: "เสร็จสิ้น",
              รอดำเนินการ: "รอดำเนินการ",
              ยกเลิก: "ยกเลิก",
            };
            return row.status === statusMap[selectedTab];
          });

      setRow(filteredRows);
      // if (!searchData) {
      setDocumentList(documentList);
      // }
    } catch (error) {
      console.error("Error fetching data:", error);
      setRow([]);
      setDocumentList([]);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500); // เพิ่ม delay 0.5 วินาที
    }
  };

  const handleDetailPerson = async () => {
    try {
      setLoading(true)
      var DataPerson = {
        document_no: document_no,
        priority: priority,
      };
      var { data } = await webapi.post(`${APIEndpointWeb.PostDetailPerson}`, DataPerson,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      setResWitness(data.result ? data.result : {} as IDetailWitness);
      setLoading(false)
    } catch (error) {
      console.log(error);
      setLoading(false)
    }
  }
  const handleChangePrefix = (event: SelectChangeEvent<string>) => {
    setSelectedValue(event.target.value as string);
  };

  const handleChangeName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNameData(event.target.value.trimStart());
  };

  // const handleChangeCid = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   let inputValue = event.target.value.replace(/\D/g, "").slice(0, 13); // Remove all non-digits and limit to 13 characters

  //   setCidData(inputValue);
  //   if (inputValue.length === 13) {
  //     setError(false); // Valid input, clear error
  //   } else {
  //     setError(true); // Invalid input, show error
  //   }
  // };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleCopy = (text: any) => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000); // รีเซ็ตข้อความคัดลอกหลัง 2 วินาที
  };

  const handleOpenViewOrderDoc = (row: tableData) => {
    // history.push("/detail-personal-document", {
    //   message: "detail_doc",
    //   datadetail: row,
    // });
    history.push({
      pathname: "/document-pending",
      search: '?page=1',
      state: { datadetail: row, message: "detail_doc", }, // ส่งค่าไปใน state
    });
  };

  const handleOpenOrderDoc = (data: {
    priority: string;
    document_no: string;
  }) => {
    // console.log("priority :>> ", data.priority);
    setPriority(data.priority);
    setDocument_no(data.document_no);
    setOpenOrderDocDialog(true);
  };

  const handleSave = async () => {
    try {
      setOpenOrderDocDialog(false);
      setLoading(true)
      const dataApi = {
        document_no: document_no,
        priority: priority,
        cid: cidData,
        prefix: selectedValue,
        name: nameData,
      };
      var { data } = await webapi.post(
        APIEndpointWeb.PostChangePerson,
        dataApi,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );

      // if (error.response.status === 400 && error.response.data === 'CID priotiry 2 invalid') {

      // } else if (error.response.status === 400) {
      //   setOpenNoInformationFound(true);
      //   setErrorTextStatus(error.response.data)
      // } else {
      //   Swal.fire({
      //     title: error.response.data.status_result.status_message_th,
      //     icon: "error",
      //   });
      // }


      if (data.message_code === 400) {
        setOpenErrorDialog(true)
      } else {
        setOpenSuccessDialog(true); //ตอนเปิด modal sucess
      }
      setLoading(false)
    } catch (error) {
      // if (error && typeof error === "object" &&"response" in error &&typeof (error as any).response === "object" &&(error as any).response !== null) {
      //   const response = (error as any).response;
      //   if (response.status === 400 && response.data === 'CID priotiry 2 invalid') {
      //     // setOpenErrorDialog(true)
      //   } else if (response.status === 400) {
      //     setOpenErrorDialog(true)
      //     setErrorTextStatus(response.data)
      //   }
      //   setLoading(false)
      // } else {
      //   setLoading(false)
      //   console.log(error);
      // }
      if (
        error &&
        typeof error === "object" &&
        "response" in error &&
        typeof (error as any).response === "object" &&
        (error as any).response !== null
      ) {
        const response = (error as any).response;

        if (response.status === 400) {
          const message = response.data?.message;

          if (message === 'CID priotiry 4 invalid') {
            setOpenErrorDialog(true);
            setErrorTextStatus(response.data); // คุณส่งทั้ง object
          } else if (message === 'CID priotiry 2 invalid') {
            setOpenErrorDialog(true);
            setErrorTextStatus(response.data); // อีกตัวแปร
          } else {
            setOpenErrorDialog(true);
            setErrorTextStatus(response.data); // fallback message
          }
        }

        // setOpenErrorDialog(true); //ตอนเปิด modal error
        setLoading(false)
      }
    };

    // const handleStop = (e: any, data: any, index: number) => {
    //   if (items[index].disabled) return; // ❌ ป้องกันการลาก item ที่ disabled

    //   const newItems = [...items];
    //   const movedItem = newItems.splice(index, 1)[0];

    //   let newIndex = index + (data.y > 10 ? 1 : data.y < -10 ? -1 : 0);

    //   if (newIndex < 3) newIndex = 3;
    //   if (newIndex >= newItems.length + 1) newIndex = newItems.length;

    //   newItems.splice(newIndex, 0, movedItem);
    //   console.log('newItems :>> ', newItems);
    //   setItems(newItems);
    // };

    // const formatThaiYear = (date: dayjs.Dayjs | null) => {
    //   return date ? date.format("DD/MM/YYYY") + `` : "";
    // };
  }

    const isValidThaiIdCard = (id: string): boolean => {
      if (!/^[1-9]\d{12}$/.test(id)) return false;

      let sum = 0;
      for (let i = 0; i < 12; i++) {
        sum += parseInt(id.charAt(i)) * (13 - i);
      }
      const checkDigit = (11 - (sum % 11)) % 10;

      return checkDigit === parseInt(id.charAt(12));
    };

    const handleChangeCid = (event: React.ChangeEvent<HTMLInputElement>) => {
      let inputValue = event.target.value.replace(/\D/g, "").slice(0, 13); // Remove non-digit characters and limit to 13

      setCidData(inputValue);

      if (inputValue.length === 13 && isValidThaiIdCard(inputValue)) {
        setError(false); // Valid
      } else {
        setError(true); // Invalid
      }
    };

    return (
      <Grid>
        <LoadingIndicator open={loading} />
        <TableContainer
          component={Paper}
          sx={{
            mt: 1,
            borderRadius: "12px",
            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.08)",
            maxHeight: "60vh",
            width: "100%",
            overflowX: "auto",
            display: "inline-block",
            [`@media (max-width:600px)`]: { maxWidth: "570px" }, // xs
            [`@media (min-width:600px) and (max-width:960px)`]: {
              maxWidth: "700px",
            }, // sm
          }}
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            sx={{
              minWidth: isMobile ? "500px" : isTablet ? "570px" : "570px",
            }}
          >
            <TableHead>
              <TableRow
                sx={{
                  position: "sticky",
                  top: 0,
                  zIndex: 10,
                }}
              >
                <TableCell sx={{ backgroundColor: "#EAF1F9" }} align="center">
                  ลำดับ
                </TableCell>
                <TableCell sx={{ backgroundColor: "#EAF1F9" }}>
                  เลขที่เอกสาร
                </TableCell>
                <TableCell sx={{ backgroundColor: "#EAF1F9" }}>
                  ประเภทเอกสาร
                </TableCell>
                <TableCell sx={{ backgroundColor: "#EAF1F9" }}>
                  วันที่สร้างเอกสาร
                </TableCell>
                <TableCell sx={{ backgroundColor: "#EAF1F9", pl: "26px" }}>
                  สถานะ
                </TableCell>
                <TableCell sx={{ backgroundColor: "#EAF1F9", pl: "30px" }}>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {row.length > 0 ? (
                row
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row: tableData, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">{index + 1}</TableCell>

                      <TableCell
                        sx={{
                          maxWidth: "150px", // Set maximum width of cell
                          overflow: "hidden",
                          whiteSpace: "pre-wrap",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <Tooltip
                          title={
                            <span
                              style={{
                                wordBreak: "break-all",
                                lineHeight: "1.5",
                              }}
                            >
                              {row.document_no}
                              <IconButton
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevent tooltip from disappearing when clicking copy
                                  handleCopy(row.document_no);
                                }}
                                sx={{ ml: 1, color: "white" }} // Set icon color for readability
                              >
                                <ContentCopyIcon
                                  sx={{
                                    fontSize: 16,
                                    cursor: "pointer",
                                    position: "absolute",
                                  }}
                                />
                              </IconButton>
                            </span>
                          }
                          arrow
                        >
                          <Typography
                            variant="body2"
                            sx={{
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                              display: "block",
                              cursor: "pointer",
                            }}
                          >
                            {row.document_no}
                          </Typography>
                        </Tooltip>
                      </TableCell>

                      <TableCell>{row.type}</TableCell>

                      <TableCell sx={{ color: "#587889" }}>
                        {/* {row.create_at
                            ? (() => {
                                const date = new Date(row.create_at);
                                if (isNaN(date.getTime())) return "-"; 
                                const year = date.getFullYear();
                                const buddhistYear = year + 543;
                                const day = date
                                  .getDate()
                                  .toString()
                                  .padStart(2, "0");
                                const month = (date.getMonth() + 1)
                                  .toString()
                                  .padStart(2, "0");
                                return `${day}/${month}/${buddhistYear}`;
                              })()
                            : "-"} */}
                        {row.create_at}

                      </TableCell>

                      <TableCell>
                        <Box
                          sx={{
                            display: "inline-block",
                            backgroundColor:
                              row.status === "เสร็จสิ้น"
                                ? "#F7FDF9"
                                : row.status === "ยกเลิก"
                                  ? "#FFF5F5"
                                  : row.status === "รอดำเนินการ"
                                    ? "#fffaf6"
                                    : "",
                            color:
                              row.status === "เสร็จสิ้น"
                                ? "#18A14C"
                                : row.status === "ยกเลิก"
                                  ? "#EE4444"
                                  : row.status === "รอดำเนินการ"
                                    ? "#FFA500"
                                    : "",
                            padding: "4px 8px",
                            borderRadius: "12px",
                          }}
                        >
                          {row.status === "เสร็จสิ้น"
                            ? "เสร็จสิ้น"
                            : row.status === "ยกเลิก"
                              ? "ยกเลิก"
                              : row.status === "รอดำเนินการ"
                                ? "รอดำเนินการ"
                                : ""}
                        </Box>
                      </TableCell>

                      <TableCell align="center">
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <Box sx={buttonContainerSx}>
                            <Button
                              onClick={() => handleOpenViewOrderDoc(row)}
                              size="small"
                              sx={{ color: "#2F4491", minWidth: "auto" }}
                            >
                              <VisibilityIcon sx={{ fontSize: "16px" }} />
                            </Button>
                          </Box>
                          {row.priority === "1" && row.status_edit === true ? (
                            <Box sx={buttonContainerSx}>
                              <Button
                                onClick={() => handleOpenOrderDoc(row)}
                                size="small"
                                sx={{ color: "#212529", minWidth: "auto" }}
                              >
                                <BorderColorIcon sx={{ fontSize: "16px" }} />
                              </Button>
                            </Box>
                          ) : ''}

                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6}>
                    <Grid
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        flexDirection: "column",
                      }}
                    >
                      <img
                        src={no_data}
                        alt="no_data"
                        style={{
                          width: 65,
                          height: "auto",
                        }}
                      />
                      <Typography>ไม่มีข้อมูล</Typography>
                    </Grid>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          {/* Pagination */}
          <TablePagination
            rowsPerPageOptions={[20, 40, 100]}
            component="div"
            count={row.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              position: "sticky",
              bottom: 0,
              backgroundColor: "#fff",
              zIndex: 10,
            }}
          />
        </TableContainer>
        {/* //dialogopen OrderDoc */}
        <Dialog
          open={openOrderDocDialog}
          onClose={(event, reason) => {
            if (reason === "backdropClick" || reason === "escapeKeyDown") {
              return;
            }
            handleSave();
          }}
        >
          <Box sx={{ padding: 3.5, width: "max(32vw)" }}>
            <Grid container sx={{ display: "flex", alignItems: "center" }}>
              <Grid item>
                <img
                  src={icon_edit}
                  alt="รูปภาพ"
                  style={{
                    width: 25,
                    height: "auto",
                    marginRight: 8, // Adds space between the image and text
                  }}
                />
              </Grid>
              <Grid item>
                <Typography
                  sx={{ color: "#2F4165", fontSize: "19px", fontWeight: 700 }}
                >
                  เปลี่ยนแปลงพยาน (ลำดับที่ 2)
                </Typography>
              </Grid>
              <Grid item xs sx={{ display: "flex", justifyContent: "flex-end" }}>
                <IconButton
                  aria-label="delete"
                  onClick={() => setOpenOrderDocDialog(false)}
                >
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>

            <Divider sx={{ mt: 2 }} />
            <Grid container sx={{ pt: 2, gap: 1 }}>
              <Grid item xs={12}>
                <Typography variant="body1" sx={{ color: "#000", ml: 1.3 }}>
                  คำนำหน้าชื่อ
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Select
                  value={selectedValue !== undefined ? selectedValue : resWitness.prefix || ""}
                  onChange={handleChangePrefix}
                  displayEmpty
                  variant="outlined"
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "26px", // Apply border-radius to the input container
                    },
                    "& fieldset": {
                      borderRadius: "26px", // Apply border-radius to the fieldset (border)
                    },
                  }}
                >
                  {prefix.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
              <Grid item xs={12} sx={{ mt: 2 }}>
                <Typography variant="body1" sx={{ color: "#000", ml: 1.3 }}>
                  ชื่อ-นามสกุล
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  value={nameData !== undefined ? nameData : resWitness.name || ""}
                  // onChange={handleChangeName}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const regex = /^[A-Za-zก-๙\s]*$/; // ตัวอักษรภาษาอังกฤษ และภาษาไทย
                    if (regex.test(inputValue)) {
                      handleChangeName(
                        e as React.ChangeEvent<HTMLInputElement>
                      );
                    }
                  }}
                  placeholder="ชื่อ-นามสกุล"
                  id="outlined-basic"
                  variant="outlined"
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "26px",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sx={{ mt: 2 }}>
                <Typography variant="body1" sx={{ color: "#000", ml: 1.3 }}>
                  เลขประจำตัวประชาชนของพยาน
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  value={cidData !== undefined ? cidData : resWitness.cid || ""}
                  onChange={handleChangeCid}
                  placeholder="กรุณากรอกเลขประจำตัวประชาชนพยาน"
                  id="outlined-basic"
                  variant="outlined"
                  inputProps={{
                    inputMode: "numeric",
                    pattern: "\\d{1}-\\d{4}-\\d{5}-\\d{2}-\\d{1}",
                  }} // Ensure only numeric input
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "26px",
                    },
                  }}
                  error={error}
                  helperText={
                    error
                      ? "กรูณากรอกเลขประจำตัวประชาชนของพยานให้ครบ 13 หลัก"
                      : ""
                  }
                />
              </Grid>
            </Grid>

            {/* <div style={{ width: '100%', margin: '0 auto', paddingTop: '15px' }}>
            {items.map((item, index) => (
              <div key={item.id} style={{ display: 'flex', alignItems: 'center', marginBottom: '13px' }}>

                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: item.disabled ? '#eff3f6' : '#ffffff',
                    borderRadius: '15px',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    flexShrink: 0, padding: '7px',
                  }}
                >
                  <Typography style={{ paddingRight: 3, color: item.disabled ? '#6B6B6B' : '#333333' }}>ลำดับ {index + 1}</Typography>
                </div>

                <Draggable
                  axis="y"
                  position={{ x: 0, y: 0 }}
                  onStop={(e, data) => handleStop(e, data, index)}
                  disabled={item.disabled}
                >
                  <div
                    style={{
                      flexGrow: 1,
                      background: item.disabled ? '#eff3f6' : '#ffffff',
                      padding: '17px',
                      marginLeft: '10px',
                      borderRadius: '15px',
                      cursor: item.disabled ? 'not-allowed' : 'grab',
                      userSelect: 'none',
                      transition: 'transform 0.1s ease-out',
                      willChange: 'transform',
                      boxShadow: item.disabled ? 'none' : '0px 2px 5px rgba(0, 0, 0, 0.2)',
                    }}
                  >
                    <Grid container>
                      <Grid item>
                        <Typography>{item.content}</Typography>
                        <Typography sx={{ fontSize: "14px", color: "#6B6B6B" }}>ppnaravittt@one.th</Typography>
                      </Grid>
                      <Grid item sx={{ display: 'flex', justifyContent: 'flex-end', flexGrow: 1, alignItems: 'center' }}>

                        <img
                          src={icon_drag}
                          alt="รูปภาพ"
                          style={{
                            width: 16,
                            height: "auto",
                            marginRight: 8,
                            visibility: item.disabled ? 'hidden' : 'inherit',
                          }}
                        />

                      </Grid>
                    </Grid>

                  </div>

                </Draggable>
              </div>
            ))}
          </div> */}
            <DialogActions>
              <Box
                sx={{
                  mt: 10,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Button
                  disabled={!selectedValue || !nameData || cidData?.length !== 13 || !isValidThaiIdCard(cidData)}
                  sx={{
                    padding: "9px 40px",
                    backgroundColor: !selectedValue || !nameData || cidData?.length !== 13 || !isValidThaiIdCard(cidData)
                      ? "#E6E6E6"
                      : "#0288D1",
                    color: "#fff",
                    borderRadius: "20px",
                    "&:hover": {
                      backgroundColor: !selectedValue || !nameData || cidData?.length !== 13 || !isValidThaiIdCard(cidData)
                        ? "#E6E6E6"
                        : "#0277BD",
                    },
                  }}
                  onClick={handleSave}
                >
                  บันทึกการเปลี่ยนแปลง
                </Button>
              </Box>
            </DialogActions>
          </Box>
        </Dialog>
        {/* //enddialogopen OrderDoc */}

        <DialogSuccessEditTable
          setOpenSuccessDialog={setOpenSuccessDialog}
          openSuccessDialog={openSuccessDialog}
        />
        <DialogNoInformationFound
          setOpenErrorDialog={setOpenErrorDialog}
          openErrorDialog={openErrorDialog}
          errorTextStatus={errorTextStatus}
          errorTextStatus2={errorTextStatus2}
        />
      </Grid>
    );
  }
